import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_secured')({
  loader: async ({ context }) => {
    await context.getInstance('i18n', '@myn/mui');
    await context.getInstance('i18n', '@mint-lib/tw-components');
    await context.getInstance('flagsmith', '@mint/arm');
  },
  async beforeLoad({ context, location }) {
    const isAuthenticated = await context.isAuthenticated();
    const isRedmillUser = await context.isRedmillUser();
    const isRedmillUserFlagEnabled = await context.isFlagEnabled(
      '@mint/arm',
      'aiRedmillUser',
    );
    const availableRedmillPaths = [
      '/ai-hub',
      '/privacy-policy',
      '/company-profile/',
    ];

    const checkIsAvailableRedmillPath = () => {
      return availableRedmillPaths.some((path) =>
        location.pathname.startsWith(path),
      );
    };

    if (!isAuthenticated) {
      console.log('redirecting to login from secured route');
      throw redirect({
        to: '/login',
        search: {
          next: location.href,
        },
      });
    }

    if (
      isRedmillUser &&
      isRedmillUserFlagEnabled &&
      !checkIsAvailableRedmillPath()
    ) {
      throw redirect({
        to: '/ai-hub',
      });
    }

    if (
      !(await context.profileHelpers.isAgencyCompany()) &&
      !!location.pathname.includes('/agency-hub')
    ) {
      throw redirect({
        to: '/campaigns',
      });
    }

    if (
      (await context.profileHelpers.isAgencyCompany()) &&
      !!location.pathname.includes('/company-profile/users-management/user')
    ) {
      throw redirect({
        to: '/agency-hub/users-management/user',
      });
    }

    if (
      (await context.profileHelpers.isAgencyCompany()) &&
      !location.pathname.includes('/agency-hub')
    ) {
      throw redirect({
        to: '/agency-hub',
      });
    }

    return context;
  },
});
